import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
import state from "./states";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
